import type { FileList } from "../../../parts/filelist/filelist"

type OrderOverviewState = {
  activeFilePopup: string
}

type OrderDetailState = {
  orders: { [key: string]: OrderDetail }
}

type OrderDetail = {
  cardCode: string
  cardName: string
  docDate: string
  deliveryDate: string
  orderType: "own" | "channel"
  refNum: string
  docEntry: number
  steps: {
    step1: {
      attachments: FileList
      date: string
    }
    step2: {
      attachments: FileList
      date: string
    }
    step3: {
      attachments: FileList
      date: string
    }
    step4: {
      attachments: FileList
      date: string
    }
  }
  attachments: FileList
}
type OrderDetailFormState = {
  selectedOrder: string
}

let orderOverview: OrderOverviewState = {
  activeFilePopup: "",
}

let orderDetailFormState: OrderDetailFormState = {
  selectedOrder: "",
}
let orderDetail: OrderDetailState

export let DATOrder = {
  orderOverview,
  orderDetail,
  orderDetailFormState,
}
